import type { PropsWithChildren } from 'react';

export const ScreenContentContainer = ({ children }: PropsWithChildren) => {
  return (
    <div className="flex flex-col items-center justify-between px-16 pt-16 h-full">
      {children}
    </div>
  );
};
